import { useStore } from "../../hooks/store";
import { Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ChildModal = () => {
  const appStore = useStore();

  const { open, formChildren } = appStore.childModal;
  const handleCloseChild = () => appStore.closeChildModal();

  return (
    <Modal open={open} onClose={handleCloseChild} className="modal">
      <div className="modal_contatiner">
        <CloseIcon onClick={handleCloseChild} className="close_modal" />

        {formChildren}
      </div>
    </Modal>
  );
};
export default function FromModalProvider({ children }) {
  const appStore = useStore();
  const { open, formChildren } = appStore.form;

  const handleClose = () => {
    appStore.form.callBack && appStore.form.callBack();
    appStore.closeForm();
  };
  return (
    <>
      {children}
      <Modal open={open} onClose={handleClose} className="modal">
        <div className="modal_contatiner">
          <CloseIcon onClick={handleClose} className="close_modal" />
          {formChildren}
          <ChildModal />
        </div>
      </Modal>
    </>
  );
}
